import getNonHiddenPaymentOptionsForSelectedCategory from './getNonHiddenPaymentOptionsForSelectedCategory';
import {getSelectedPaymentOptionIndex} from './getSelectedPaymentOptionIndex';

export default (state) => {
  const selectedPaymentOptionIndex = getSelectedPaymentOptionIndex(state);
  const nonHiddenPaymentOptionsForSelectedCategory = getNonHiddenPaymentOptionsForSelectedCategory(state);
  
  return nonHiddenPaymentOptionsForSelectedCategory
    ?.findIndex(paymentOption => paymentOption.apiIndex === selectedPaymentOptionIndex) !== -1;
};
